<template>
  <div class='box-content'>
    <siteSelect :showArea='showSite' :initialSiteId='maintenanceSiteId' @change='siteChange'></siteSelect>
    <div class='right-box'>
      <!-- 查询区域 -->
      <div class='table-page-search-wrapper'>
        <a-form layout='inline'>
          <a-row :gutter='24'>
            <a-col :md='6' :sm='8'>
              <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='巡检类型'>
                <j-dict-select-tag
                  placeholder='请选择巡检类型'
                  dictCode='inspection_type'
                  v-model='queryParam.category'
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>

            <a-col :md='6' :sm='8' v-if='isRoot'>
              <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='巡检人'>
                <a-tree-select
                  style='width: 100%'
                  :dropdownStyle="{ maxHeight: '200px', overflow: 'auto' }"
                  :treeData='userTree'
                  v-model='queryParam.userId'
                  placeholder='请选择巡检人'
                  dropdownClassName='selects'
                  show-search
                  treeNodeFilterProp='title'
                >
                  <template slot='title' slot-scope='{ title }'>
                    {{ title }}
                  </template>
                </a-tree-select>
              </a-form-item>
            </a-col>

            <a-col :md='6' :sm='8'>
              <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='巡检模板'>
                <a-select
                  showSearch
                  :allowClear='true'
                  placeholder='请选择巡检模板'
                  optionFilterProp='children'
                  v-model='queryParam.templateId'
                >
                  <a-select-option v-for='(item, key) in templateOptions' :key='key' :value='item.id'>
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md='6' :sm='8'>
              <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='巡检结果'>
                <j-dict-select-tag
                  placeholder='请选择巡检结果'
                  dictCode='normal_status'
                  v-model='queryParam.status'
                ></j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md='6' :sm='8' v-if='!isRoot'>
              <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='天气情况'>
                <a-input placeholder='请输入天气情况' v-model='queryParam.weather' />
              </a-form-item>
            </a-col>

            <template v-if='toggleSearchStatus'>
              <!--            <a-col :md="6" :sm="8">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="天气情况">
                              <j-dict-select-tag
                                placeholder="请选择天气情况"
                                dictCode="weather_status"
                                v-model="queryParam.weather"
                              ></j-dict-select-tag>
                            </a-form-item>
                          </a-col>

                          <a-col :md="6" :sm="8">
                            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="湿度">
                              <j-dict-select-tag
                                placeholder="请选择湿度"
                                dictCode="humidity_status"
                                v-model="queryParam.humidity"
                              ></j-dict-select-tag>
                            </a-form-item>
                          </a-col>-->

              <!-- <a-col :md="6" :sm="8" v-if="isRoot">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="天气情况">
                  <a-input placeholder="请输入天气情况" v-model="queryParam.weather" />
                </a-form-item>
              </a-col> -->

              <!-- <a-col :md="6" :sm="8">
                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="湿度">
                  <a-input placeholder="请输入湿度" v-model="queryParam.humidity" />
                </a-form-item>
              </a-col> -->

              <!--              <a-col :md="6" :sm="8">-->
              <!--                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="">-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->

              <!--              <a-col :md="6" :sm="8">-->
              <!--                <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="">-->
              <!--                </a-form-item>-->
              <!--              </a-col>-->

              <a-col :md='6' :sm='8'>
                <a-form-item :labelCol='labelCol' :wrapperCol='wrapperCol' label='开始时间'>
                  <a-range-picker
                    :show-time="{ format: 'HH:mm:ss' }"
                    format='YYYY-MM-DD HH:mm:ss'
                    v-model='dates.stime'
                    :placeholder="['开始时间', '结束时间']"
                    @change='onDateStime'
                  />
                </a-form-item>
              </a-col>
              <a-col :md='6' :sm='8'>
                <a-form-item style='margin-left: 50px' :labelCol='labelCol' :wrapperCol='wrapperCol' label='结束时间'>
                  <a-range-picker
                    :show-time="{ format: 'HH:mm:ss' }"
                    format='YYYY-MM-DD HH:mm:ss'
                    v-model='dates.etime'
                    :placeholder="['开始时间', '结束时间']"
                    @change='onDateEtime'
                  />
                </a-form-item>
              </a-col>
            </template>
          </a-row>
        </a-form>
      </div>

      <!-- 操作按钮区域 -->
      <div class='table-operator inspection-toolbar'>
        <div v-if="loginUser === 'admin' || selectedRowKeys.length > 0" class='inspection-actions'>
          <a-button v-if="loginUser === 'admin'" @click='handleAdd' type='primary' icon='plus'>新增(仅管理员)</a-button>
          <template v-if='selectedRowKeys.length > 0'>
            <a-button icon='download' :loading='exportingWord' @click='handleBatchExportWord'>
              {{ exportingWord ? '正在生成压缩包' : '批量导出 Word' }}
            </a-button>
            <a-button type='danger' ghost icon='delete' :disabled='exportingWord' @click='batchDel'>批量删除</a-button>
          </template>
        </div>
        <div class='inspection-search-actions'>
          <a-button @click='searchQuery' icon='search' type='primary' ghost>查询</a-button>
          <a-button @click='searchReset' icon='reload'>重置</a-button>
          <a-button @click='handleToggleSearch'>
            {{ toggleSearchStatus ? '收起' : '展开' }}
            <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
          </a-button>
        </div>
      </div>

      <!-- table区域-begin -->
      <div>
        <div class='ant-alert ant-alert-info' style='margin-bottom: 16px'>
          <i class='anticon anticon-info-circle ant-alert-icon'></i> 已选择
          <a style='font-weight: 600'>{{ selectedRowKeys.length }}</a
          >项
          <a style='margin-left: 24px' @click='onClearSelected'>清空</a>
        </div>

        <a-table
          ref='table'
          size='middle'
          bordered
          rowKey='id'
          :columns='columns'
          :dataSource='dataSource'
          :pagination='ipagination'
          :loading='loading'
          :rowSelection='{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }'
          @change='handleTableChange'
        >
          <span slot='action' slot-scope='text, record'>
            <a @click='handleDetail(record)'>查看</a>
            <!--                      <a-divider type="vertical" />
                                            <a-dropdown>
                                              <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                                              <a-menu slot="overlay">
                                                <a-menu-item>
                                                  <a href="javascript:;" @click="handleEdit(record)">编辑</a>
                                                </a-menu-item>
                                                <a-menu-item>
                                                  <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                                                    <a>删除</a>

                                                  </a-popconfirm>
                                                </a-menu-item>
                                              </a-menu>
                                            </a-dropdown>-->
            <a-divider type='vertical' />
            <a @click='handleExportWord(record)'>导出</a>
          </span>
        </a-table>
      </div>
      <!-- table区域-end -->

      <!-- 表单区域 -->
      <inspectionRecord-drawer ref='modalForm' :pagePath='pagePath' @ok='modalFormOk'></inspectionRecord-drawer>
    </div>
  </div>
</template>

<script>
import InspectionRecordDrawer from './modules/InspectionRecordDrawer'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { queryUserTreeList } from '@/api/api'
import {  downloadFile, getAction } from '@api/manage'
import moment from 'moment'
import siteSelect from '@/components/page/siteSelect'

export default {
  name: 'InspectionRecordList',
  components: {
    InspectionRecordDrawer,
    siteSelect
  },
  data() {
    return {
      isRoot: false,
      exportingWord: false,
      showSite: true,
      /* 模板列表*/
      templateOptions: [],
      maintenanceSiteId: this.$route.query.siteId || null,
      openedMaintenanceRecord: null,
      queryParam: this.$route.query.siteId ? {
        scope: 1, scopeId: this.$route.query.siteId, siteId: this.$route.query.siteId,
        templateId: (this.$route.query.scopeKey || '').startsWith('template:') ? this.$route.query.scopeKey.substring(9) : undefined
      } : {},
      pagePath: '/om/inspection/record',
      autoLoadInit:false,
      pageTitle: '巡检单',
      userTree: [], //人员信息
      loginUser: '',
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: false
      },
      isorter: {
        column: 'create_time',
        order: 'desc'
      },
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          dataIndex: 'siteName',
          colName: 'siteId',
          title: '站点',
          align: 'center'
        },
        {
          dataIndex: 'userId_userName',
          colName: 'user_id',
          title: '巡检人',
          align: 'center'
        },
        {
          dataIndex: 'category_dictText',
          colName: 'category',
          title: '巡检类型',
          align: 'center',
          sorter: false
        },
        {
          dataIndex: 'templateName',
          colName: 'template_id',
          title: '巡检模板',
          align: 'center',
          sorter: false
        },
        {
          dataIndex: 'stime',
          colName: 'stime',
          title: '开始时间',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'etime',
          colName: 'etime',
          title: '结束时间',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'durationTime',
          colName: 'durationTime',
          title: '巡检时长',
          align: 'center',
          sorter: true
        },
        {
          dataIndex: 'weather_dictText',
          colName: 'weather',
          title: '天气情况',
          align: 'center',
          sorter: false
        },
        {
          dataIndex: 'temperature',
          colName: 'temperature',
          title: '温度（°C）',
          align: 'center',
          sorter: false
        },
        {
          dataIndex: 'humidity',
          colName: 'humidity',
          title: '湿度（%RH）',
          align: 'center',
          sorter: false
        },
        {
          dataIndex: 'status_dictText',
          colName: 'status',
          title: '巡检结果',
          align: 'center',
          sorter: false
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 120,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mixins: [JeecgListMixin],
  created() {
    console.log('created页面',this.autoLoadInit)
    if (window.localStorage.getItem('projectCode')) {
      if (window.localStorage.getItem('projectCode') == 'meitang') {
        this.showSite = false
      }
    }

    if (localStorage.getItem('pro__Login_Userinfo')) {
      this.userInfo = JSON.parse(localStorage.getItem('pro__Login_Userinfo')).value
      this.isRoot =
        this.userInfo.roleList.includes('administrator') ||
        this.userInfo.roleList.includes('tenant_admin') ||
        this.userInfo.roleList.includes('inspection')
    }

    if (!this.isRoot) {
      this.queryParam.userId = this.userInfo.id
    }
    console.log('this.isRoot', this.isRoot)

    this.loginUser = JSON.parse(localStorage.getItem('pro__Login_Username')).value
    // 加载巡检模板列表
    this.queryTemplateList()
    // 加载人员信息
    this.loadTreeList()
  },
  computed: {},
  mounted() {
    this.openMaintenanceRecord()
  },
  watch: {
    '$route.query': function(query) {
      this.onClearSelected()
      this.maintenanceSiteId = query.siteId || null
      this.openedMaintenanceRecord = null
      this.$set(this.queryParam, 'siteId', query.siteId || undefined)
      this.$set(this.queryParam, 'scopeId', query.siteId || undefined)
      this.$set(this.queryParam, 'scope', query.siteId ? 1 : undefined)
      this.$set(this.queryParam, 'templateId', (query.scopeKey || '').startsWith('template:') ? query.scopeKey.substring(9) : undefined)
      this.loadData(1)
      this.openMaintenanceRecord()
    }
  },
  methods: {
    handleBatchExportWord() {
      if (this.exportingWord) return
      if (!this.selectedRowKeys.length) {
        this.$message.warning('请选择巡检记录！')
        return
      }
      this.exportingWord = true
      const fileName = '巡检单批量导出_' + moment().format('YYYYMMDD_HHmmss') + '.zip'
      return downloadFile(fileName, this.pagePath + '/exportWordBatch', this.selectedRowKeys.slice(), 'post')
        .catch(() => this.$message.error('批量导出失败，请稍后重试'))
        .finally(() => { this.exportingWord = false })
    },
    openMaintenanceRecord() {
      const id = this.$route.query.businessId
      if (!id || this.openedMaintenanceRecord === id) return
      this.openedMaintenanceRecord = id
      getAction(`${this.pagePath}/${id}`).then(res => {
        if (String(this.$route.query.businessId) !== String(id)) return
        if (res.success && res.result) this.handleDetail(res.result)
        else this.$message.warning(res.message || '记录不存在或无权查看')
      }).catch(() => this.$message.error('读取完成记录失败'))
    },
    handleExportWord(record) {
      let site = String(record.siteName || '未知站点').replace(/[\\/:*?"<>|\u0000-\u001f\u007f]/g, '_').trim().replace(/[ .]+$/, '')
      site = (site || '未知站点').slice(0, 50)
      let type = record.category_dictText || (record.category == null || record.category === '' ? '巡检类型未填写' : String(record.category))
      type = String(type).replace(/[\\/:*?"<>|\u0000-\u001f\u007f]/g, '_').trim().replace(/[ .]+$/, '')
      type = (type || '巡检类型未填写').slice(0, 50)
      const time = record.stime ? moment(record.stime).format('YYYYMMDDHHmm') : '开始时间未填写'
      downloadFile('巡检单(' + site + '_' + type + '_' + time + ').docx', this.pagePath + '/exportWord', { id: record.id })
    },
    handleExportXls(fileName, record) {
      var id = record.id
      if (window.localStorage.getItem('projectCode') == 'meitang') {
        var url = this.pagePath + '/export'
      }else{
        var url = this.pagePath + '/exportXls'
      }
      downloadFile(fileName + '.xlsx', url, { id })
    },
    // 批量导出
    handleExportXlsAll() {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择' + this.pageTitle + '记录！')
        return
      } else {
        let fileName = this.pageTitle + '导出文件'
        let param = { }
        if (this.selectedRowKeys && this.selectedRowKeys.length > 0) {
          param['ids'] = this.selectedRowKeys.join(',')
        }
        var url = this.pagePath + '/exportBatch'
        downloadFile(fileName + '.xls', url, param)
      }
    },
    // loadData(arg) {
    //   if (arg == undefined) {
    //     arg = 1
    //   }
    //   this.initTableData(arg)
    // },
    moment,
    // 站点选择
    siteChange(data) {
      this.onClearSelected()
      console.log(data)
      // debugger
      if (this.maintenanceSiteId && String(data.data.id) !== String(this.maintenanceSiteId)) {
        this.maintenanceSiteId = null
        this.$delete(this.queryParam, 'templateId')
      }
      this.$delete(this.queryParam, 'siteId')
      this.queryParam.scopeId = data.data.id
      this.queryParam.scope = data.scope
      if (this.$refs.modalForm) {
        this.$refs.modalForm.siteName = data.data.name
        this.$refs.modalForm.siteId = data.data.id
      }
      this.loadData()
    },
    onDateStime: function(value, dateArray) {
      this.queryParam.stimeStart = dateArray[0]
      this.queryParam.stimeEnd = dateArray[1]
    },
    onDateEtime: function(value, dateArray) {
      this.queryParam.etimeStart = dateArray[0]
      this.queryParam.etimeEnd = dateArray[1]
    },

    /* 加载 模板列表*/
    queryTemplateList() {
      var that = this
      that.templateOptions = []
      let params = { pageNo: 1,status: 1, pageSize: 10000 }
      getAction('/om/inspection/template', params).then((res) => {
        if (res.success) {
          // 模板类型
          that.templateOptions = res.result.records
          /*this.idItem = res.result
          this.form.setFieldsValue({ code: 'TPL' + moment().format('YYMMDD') + '00' + this.idItem })*/
        } else {
          console.log(res.message)
        }
      })
      // this.queryParam.arg = 1
    },

    //加载人员信息
    loadTreeList() {
      var that = this
      that.userTree = []
      // 用户
      queryUserTreeList().then((res) => {
        if (res.success) {
          for (let i = 0; i < res.result.length; i++) {
            let temp = res.result[i]
            that.userTree.push(temp)
          }
          this.loading = false
        }
      })
    },
    handleDetail: function (record) {
      record.manualSign =encodeURIComponent(record.manualSign)
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = this.pageTitle + '详情'
      this.$refs.modalForm.disableSubmit = true
      this.$refs.modalForm.showTab = true
      this.$refs.modalForm.showContact = false
      this.$refs.modalForm.activeKey = '1'
      this.$refs.modalForm.showInput = false
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.box-content {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.right-box {
  flex: 1;
  min-width: 0;
  margin-left: 10px;
}

.inspection-toolbar,
.inspection-actions,
.inspection-search-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.inspection-toolbar {
  justify-content: flex-end;
  gap: 12px;
}

.inspection-toolbar .ant-btn {
  margin: 0;
}

.ant-form-item-label > label {
  color: black;
}
</style>
